<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="$props.name"
    :rules="$props.rules"
    class="base-switch"
    tag="div"
    v-b-tooltip.hover.right
    :title="tooltip || ''"
    :style="tooltip ? { width: '35px' } : {}"
  >
    <b-form-checkbox
      v-model="modelValue"
      v-bind="$attrs"
      v-on="$listeners"
      :id="id"
      :class="{ 'is-invalid': !!errors.length }"
      :value="$props.checkedValue"
      :unchecked-value="$props.uncheckedValue"
      switch
      @change="onChange"
    >
      <slot>{{ $props.label }}</slot>
    </b-form-checkbox>

    <div v-if="!!errors.length" class="invalid-feedback">{{ errors[0] }}</div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { uniqueId, isArray } from 'lodash-es'
import { ValidationProvider } from 'vee-validate'

export default defineComponent({
  name: 'BaseSwitch',
  inheritAttrs: false,
  components: {
    ValidationProvider
  },
  props: {
    name: String,
    label: String,
    rules: String,
    tooltip: String,
    value: [Boolean, Array],
    checkedValue: {
      type: [Boolean, Number],
      default: true
    },
    uncheckedValue: {
      type: [Boolean, Number],
      default: false
    }
  },
  emits: ['input', 'toggle'],
  setup(props, { emit }) {
    const id = computed(() => `id_${uniqueId('base-switch-')}`)

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => {
        if (isArray(props.value)) {
          emit('input', !!newValue.length ? newValue : [])
        } else {
          emit('input', newValue || props.uncheckedValue)
        }
      }
    })

    const onChange = (value) => emit('toggle', value)

    return {
      id,

      modelValue,

      onChange
    }
  }
})
</script>

<style scoped>
.base-switch >>> .custom-switch {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  line-height: 1;
}

.base-switch >>> .custom-switch label::before {
  min-width: 35px;
  border-radius: 12px !important;
  left: 0;
}

.base-switch >>> .custom-switch label::after {
  top: 4px;
  left: 4px;
}

.base-switch
  >>> .custom-switch
  .custom-control-input:checked
  ~ .custom-control-label::after {
  transform: translateX(14px);
}
</style>
